import { render, staticRenderFns } from "./error.pug?vue&type=template&id=53f1073e&lang=pug&external"
import script from "./error.js?vue&type=script&lang=js&external"
export * from "./error.js?vue&type=script&lang=js&external"
import style0 from "./error.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f1073e')) {
      api.createRecord('53f1073e', component.options)
    } else {
      api.reload('53f1073e', component.options)
    }
    module.hot.accept("./error.pug?vue&type=template&id=53f1073e&lang=pug&external", function () {
      api.rerender('53f1073e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error/index.vue"
export default component.exports